import { Suspense } from 'react';

import { ErrorBoundary } from '@trello/error-boundaries';
import { useLazyComponent } from '@trello/use-lazy-component';

import type { SelectCoverProps } from './SelectCover';

export function LazySelectCover({
  boardId,
  cardId,
  traceSource,
  navigateToAddCover,
}: SelectCoverProps) {
  const SelectCover = useLazyComponent(
    () => import(/* webpackChunkName: "select-cover" */ './SelectCover'),
    {
      preload: false,
      namedImport: 'SelectCover',
    },
  );
  return (
    <Suspense fallback={null}>
      <ErrorBoundary
        tags={{
          ownershipArea: 'trello-aaaa',
          feature: 'Card Covers',
        }}
      >
        <SelectCover
          boardId={boardId}
          cardId={cardId}
          traceSource={traceSource}
          navigateToAddCover={navigateToAddCover}
        />
      </ErrorBoundary>
    </Suspense>
  );
}
